// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb_breadcrumb__EG4bE","slash":"breadcrumb_slash__pGlGz"};